import * as React from 'react';
import { Select, Spin } from 'antd';
import { observer } from 'mobx-react';

import QuoteStore from '../../stores/QuoteStore';

let busy: any = null;

export const Accounts = observer((props: any) => {
    const { read_only, disabled: disabledProp, allowClear: allowClearProp, ...rest } = props;
    const isLocked = Boolean(read_only);
    const mergedDisabled = isLocked || Boolean(disabledProp);
    const mergedAllowClear = isLocked ? false : allowClearProp !== undefined ? allowClearProp : true;

    return (
        <Select
            showSearch
            labelInValue
            filterOption={false}
            optionKeyProp={'value'}
            style={{ width: '100%' }}
            dropdownMatchSelectWidth={false}
            placeholder="Search account by name"
            notFoundContent={QuoteStore.loading_accounts ? <Spin size="small" /> : null}
            onSearch={name => {
                if (isLocked) {
                    return;
                }
                if (busy) {
                    clearTimeout(busy);
                }
                const params = {
                    search: name,
                };

                busy = setTimeout(() => QuoteStore.getAccounts(params), 400);
            }}
            {...rest}
            allowClear={isLocked ? false : mergedAllowClear}
            disabled={mergedDisabled || Boolean(rest.disabled)}
        >
            {QuoteStore.accounts.map(d => (
                <Select.Option key={d.id}>{d.name}</Select.Option>
            ))}
        </Select>
    );
});
